import { isString } from "lodash-es";

import { RouteLink } from "./route-link.model";

export function extractRouteLink(routeNameOrRoute: string | RouteLink): RouteLink {
	return isString(routeNameOrRoute) ? { route: routeNameOrRoute } : routeNameOrRoute;
}
